import { debounceTime, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { NetworkStatus } from '@cbridge-utils/network';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { coverageRuleStoreSelector, CoverageRuleAction, ICoverageRule } from '@cbridge-packages/coverage-rules';
import {
  RulesManagementAction, rulesActiveSelector, hasRuleValidationErrorsSelector, RULE_VALIDATION_DEBOUNCE,
} from '@cbridge-modules/rules-management-page';

type IState =
  & IGetSelectorStateType<typeof rulesActiveSelector>
  & IGetSelectorStateType<typeof coverageRuleStoreSelector>;

export const validateCoverageRulesEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(
    RulesManagementAction.removeRule,
    RulesManagementAction.restoreRule,
    RulesManagementAction.updateRule,
    RulesManagementAction.reorderRule,
  ),
  debounceTime(RULE_VALIDATION_DEBOUNCE),
  withLatestFrom(state$),
  filter(([, state]) => !hasRuleValidationErrorsSelector(state)),
  mergeMap(([, state]) => {
    const { networkStatus, ruleSetId } = coverageRuleStoreSelector(state);
    if (networkStatus !== NetworkStatus.Done || !ruleSetId) {
      return [];
    }
    const rules = rulesActiveSelector(state) as unknown as ICoverageRule[];
    return [CoverageRuleAction.validate.started({ ruleSetId, rules })];
  }),
);
